import Controller from 'controllers/controller';
import Binder from 'tools/binder';
import Bus from 'tools/bus';
import Animator from 'tools/animator';
import {TweenLite, Power2} from "tools/gsap";

class MenuController extends Controller {
    constructor(app, options) {
        super(app);
        
        this.options = {
            animationDuration: 0.7
        };
        
        this.options = Object.assign(this.options, options);
        
        this.binder = new Binder(this);
        this.bus = new Bus(this);
        
        this.isOpen = false;
        this.isAnimating = false;
        this.elements = { };
        this.animator = new Animator({
            elements: this.elements,
            duration: this.options.animationDuration
        });
        
        this.cacheElements();
        this.attachEvents();
        this.init();
    }

    cacheElements() {
        this.elements.menu = document.querySelector('#menu');
        this.elements.menuList = this.elements.menu.querySelector('ul');
        this.elements.menuListItems = Array.from(this.elements.menuList.querySelectorAll('li'));
        this.elements.menuLinks = Array.from(this.elements.menuList.querySelectorAll('a'));
    }
    
    attachEvents() {
        // Fetch the SharedEvents instance for the menu button so we can receive events from all buttons
        this.app.headerController.sharedEvents.menuButton
            .on('click', this.binder.bind('onMenuButtonClick'));
        
        this.elements.menuLinks.forEach(
            link => link.addEventListener('click', this.binder.bind('onLinkClick'))
        );
    }
    
    removeEvents() {
        this.app.headerController.sharedEvents.menuButton
            .off('click', this.binder.getBound('onMenuButtonClick'));

        this.elements.menuLinks.forEach(
            link => link.removeEventListener('click', this.binder.getBound('onLinkClick'))
        );
    }

    onLinkClick(event) {
        event.preventDefault();
        
        let link = event.currentTarget,
            url = link.getAttribute('href');
        
        this.app.pageController.scrollToPage(
            this.app.pageController.getPageByUrl(url)
        );
        
        this.close();
    }

    onMenuButtonClick() {
        // Ignore clicks if menu is animating
        if (this.isAnimating) {
            return;
        }
        
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Display the menu but with zero opacity
     */
    display() {
        TweenLite.set(this.elements.menu, {
            opacity: 0,
            display: 'block'
        });
    }

    /**
     * Hide the menu
     */
    hide() {
        TweenLite.set(this.elements.menu, {
            opacity: 0,
            display: 'none'
        });
    }
    
    closeMenuListItems() {
        let menuRect = this.elements.menu.getBoundingClientRect();
        
        this.elements.menuListItems.forEach(item => {
            
        });
    }
    
    init() {
        this.hide();

        TweenLite.set(this.elements.menu, {
            opacity: 0
        });

        TweenLite.set(this.elements.menuList, {
            y: -20
        });
    }
    
    open() {
        this.isAnimating = true;
        this.isOpen = true;
        
        document.body.classList.add('menu-open');
        
        this.bus.emit('open');
        
        this.display();

        this.animator.animate('menu', {
            opacity: 1
        });

        this.animator.animate('menuList', {
            y: 0,
            onComplete: () => {
                this.isAnimating = false;
                this.bus.emit('opened');
            }
        });
    }
    
    close() {
        this.isAnimating = true;
        this.isOpen = false;

        document.body.classList.remove('menu-open');
        
        this.bus.emit('close');

        this.animator.animate('menu', {
            opacity: 0
        });

        this.animator.animate('menuList', {
            y: -20,
            onComplete: () => {
                this.isAnimating = false;
                this.hide();
                this.bus.emit('closed');
            }
        });
    }
}

export default MenuController;